import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PersonListComponent } from './components/person-list/person-list.component';
import { UserRegisterComponent } from './components/user-register/user-register.component';
import { PersonRegisterComponent } from './components/person-register/person-register.component';
import { MediaUploadComponent } from './components/media-upload/media-upload.component';
import { LoginComponent } from './components/login/login.component';
import { ProfileComponent } from './components/profile/profile.component';
import { EndRegisterComponent } from './components/end-register/end-register.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { TermsComponent } from './components/terms/terms.component';
import { AboutComponent } from './components/about/about.component';
import { BlogComponent } from './components/blog/blog.component';
import { url, metaTitles, metaDescriptions, metaImages } from './modules/util/constants';
import { EditMediaComponent } from './components/edit-media/edit-media.component';
import { canActivate, canActivateAdmin } from './modules/util/auth.guard';
import { ErrorComponent } from './components/error/error.component';
import { SubscriptionListComponent } from './components/subscription-list/subscription-list.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { InteractionStatisticsComponent } from './components/interaction-statistics/interaction-statistics.component';
import { CreateActivityComponent } from './components/create-activity/create-activity.component';
import { AlliesComponent } from './components/allies/allies.component';
import { SubscriptionDetailComponent } from './components/subscription-detail/subscription-detail.component';
import { CreateArticleComponent } from './components/create-article/create-article.component';
import { ArticleListComponent } from './components/article-list/article-list.component';

const routes: Routes = [
  { path: url['home'], component: HomeComponent, 
    data: {
      title: metaTitles['home'],
      description: metaDescriptions['home'],
      ogTitle: metaTitles['home'],
      ogDescription: metaDescriptions['home'],
      ogImage: metaImages['black-logo'],
      twitterTitle: metaTitles['home'],
      twitterDescription: metaDescriptions['home'],
      twitterImage: metaImages['black-logo']
    }
  },
  { path: url['lista-perfiles'], component: PersonListComponent, 
    data: {
      title: metaTitles['lista-perfiles'],
      description: metaDescriptions['lista-perfiles'],
      ogTitle: metaTitles['lista-perfiles'],
      ogDescription: metaDescriptions['lista-perfiles'],
      ogImage: metaImages['lista-perfiles'],
      twitterTitle: metaTitles['lista-perfiles'],
      twitterDescription: metaDescriptions['lista-perfiles'],
      twitterImage: metaImages['lista-perfiles']
    }
  },
  { path: url['lista-perfiles'] + '/:filter', component: PersonListComponent,
    data: {
      title: metaTitles['lista-perfiles'],
      description: metaDescriptions['lista-perfiles'],
      ogTitle: metaTitles['lista-perfiles'],
      ogDescription: metaDescriptions['lista-perfiles'],
      ogImage: metaImages['lista-perfiles'],
      twitterTitle: metaTitles['lista-perfiles'],
      twitterDescription: metaDescriptions['lista-perfiles'],
      twitterImage: metaImages['lista-perfiles']
    }
  },
  { path: url['lista-perfiles'] + '/:filter/:locality', component: PersonListComponent,
    data: {
      title: metaTitles['lista-perfiles'],
      description: metaDescriptions['lista-perfiles'],
      ogTitle: metaTitles['lista-perfiles'],
      ogDescription: metaDescriptions['lista-perfiles'],
      ogImage: metaImages['lista-perfiles'],
      twitterTitle: metaTitles['lista-perfiles'],
      twitterDescription: metaDescriptions['lista-perfiles'],
      twitterImage: metaImages['lista-perfiles']
    }
  },
  { path: url['perfil'] + '/:id', component: ProfileComponent, 
    data: { 
      title: metaTitles['perfil'],
      description: metaDescriptions['perfil'],
      ogTitle: metaTitles['perfil'],
      ogDescription: metaDescriptions['perfil'],
      ogImage: metaImages['white-logo'],
      twitterTitle: metaTitles['perfil'],
      twitterDescription: metaDescriptions['perfil'],
      twitterImage: metaImages['white-logo']
    } 
  },
  { path: url['login'], component: LoginComponent,
    data: {
      title: metaTitles['login'],
      description: metaDescriptions['login'],
      ogTitle: metaTitles['login'],
      ogDescription: metaDescriptions['login'],
      ogImage: metaImages['white-logo'],
      twitterTitle: metaTitles['perfil'],
      twitterDescription: metaDescriptions['login'],
      twitterImage: metaImages['white-logo'],
      robots: 'noindex'
    }
  },
  { path: url['registro-1'], component: UserRegisterComponent, 
    data: {
      title: metaTitles['registro'],
      description: metaDescriptions['registro'],
      ogTitle: metaTitles['registro'],
      ogDescription: metaDescriptions['registro'],
      ogImage: metaImages['white-logo'],
      twitterTitle: metaTitles['registro'],
      twitterDescription: metaDescriptions['registro'],
      twitterImage: metaImages['white-logo']
    }
  },
  { path: url['registro-2'], component: PersonRegisterComponent, 
    data: {
      title: metaTitles['registro'],
      description: metaDescriptions['registro']
    }
  },
  { path: url['carga-imagenes'], component: MediaUploadComponent, 
    data: {
      title: metaTitles['registro'],
      description: metaDescriptions['registro']
    }
  },
  { path: url['registro-fin'], component: EndRegisterComponent, 
    data: {
      title: metaTitles['registro'] + ' - Gracias',
      description: metaDescriptions['registro']
    }
  },
  { path: url['editar-perfil'] + '/:id', component: EditProfileComponent,
    data: {
      title: 'Editar perfil escort',
    },
    canActivate: [canActivate]
  },
  { path: url['crear-actividad'] + '/:id', component: CreateActivityComponent,
    data: {
      title: 'Registrar un saludo',
    },
    canActivate: [canActivate]
  },
  { path: url['aliados'], component: AlliesComponent,
    data: {
      title: metaTitles['aliados'],
      description: metaDescriptions['aliados'],
      robots: 'noindex,nofollow'
    }
  },
  { path: url['detalle-perfil'] + '/:id', component: ProfileDetailsComponent, 
    data: {
      title: 'Detalles perfil escort'
    },
    canActivate: [canActivate]
  },
  { path: url['administracion'], component: AdministrationComponent,
    data: {
      title: 'Administrador'
    },
    canActivate: [canActivateAdmin]
  },
  { path: url['interacciones'], component: InteractionStatisticsComponent,
    data: {
      title: 'Estadísticas de interacción'
    },
    canActivate: [canActivateAdmin]
  },
  { path: url['terminos'], component: TermsComponent,
    data: {
      title: metaTitles['terminos'],
      description: metaDescriptions['terminos'],
      ogTitle: metaTitles['terminos'],
      ogDescription: metaDescriptions['terminos'],
      ogImage: metaImages['white-logo'],
      twitterTitle: metaTitles['terminos'],
      twitterDescription: metaDescriptions['terminos'],
      twitterImage: metaImages['black-logo'],
      canonical: url['terminos']
    }
  },
  { path: url['acerca-de'], component: AboutComponent, 
    data: {
      title: metaTitles['acerca-de'],
      description: metaDescriptions['acerca-de'],
      ogTitle: metaTitles['acerca-de'],
      ogDescription: metaDescriptions['acerca-de'],
      ogImage: metaImages['black-logo'],
      twitterTitle: metaTitles['acerca-de'],
      twitterDescription: metaDescriptions['acerca-de'],
      twitterImage: metaImages['black-logo']
    } 
  },
  { path: url['blog'], component: ArticleListComponent,
    data: {
      title: metaTitles['blog'],
      description: metaTitles['blog'],
      ogTitle: metaTitles['blog'],
      ogDescription: metaDescriptions['blog'],
      ogImage: metaImages['black-logo'],
      twitterTitle: metaTitles['blog'],
      twitterDescription: metaDescriptions['blog'],
      twitterImage: metaImages['black-logo']
    }
  },
  {
    path: url['contactanos'], component: ContactusComponent,
    data: {
      title: metaTitles['contactanos'],
      description: metaDescriptions['contactanos'],
      robots: 'noindex'
    }
  },
  { path: url['editar-media'] + '/:id', component: EditMediaComponent, 
    data: {
      title: 'Editar imágenes'
    },
    canActivate: [canActivate]
  },
  { path: url['suscripciones'], component: SubscriptionListComponent,
    data: {
      title: 'Planes'
    }
  },
  { path: url['detalle-suscripcion'] + '/:id', component: SubscriptionDetailComponent,
    data: {
      title: 'Detalle de suscripciones'
    },
    canActivate: [canActivateAdmin]
  },
  { path: url['crear-articulo'], component: CreateArticleComponent,
    data: {
      title: 'Crear artículo'
    },
    canActivate: [canActivateAdmin]
  },
  { path: url['404'], component: ErrorComponent, pathMatch: 'full', 
    data: {
      title: 'Página no encontrada (404)' + metaTitles['home'],
      description: 'Página no encontrada (404)' + metaDescriptions['home'],
      robots: 'noindex'
    }
  },
  { path: '**', component: ErrorComponent, pathMatch: 'full', 
    data: {
      title: metaTitles['home'],
      description: metaDescriptions['home'],
      robots: 'noindex'
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
